export default "__VITE_ASSET__Balo1aQ6__"